import * as React from 'react';
import Dialog from 'components/Dialog';
import BoxBody from 'components/BoxBody';
import AvatarEditorModal from 'components/AvatarEditorModal';
import WebcamAvatarShooter from 'components/WebcamAvatarShooter';

type Props = {
  onSuccess: () => void;
  uploadRequest: (ctx: string, name: string, blob: File, onSuccess: () => void) => void;
  loadThumbnail: (fileContextKey: string, filename: string, thumbnail: string) => void;
  fileContextKey: string;
  onRequestHide?: () => void;
};

type State = {
  view: 'webcam' | 'editor';
  image?: string;
};

class WebcamAvatarModal extends React.Component<Props, State> {
  state: State = {
    view: 'webcam',
    image: undefined,
  };

  handlePictureTaken = (image?: string) => {
    this.setState({ image, view: 'editor' });
  };

  renderEditor() {
    if (!this.state.image) {
      return null;
    }

    return (
      <AvatarEditorModal
        filename="me.png"
        image={this.state.image}
        onSuccess={this.props.onSuccess}
        onRequestHide={this.props.onRequestHide}
        loadThumbnail={this.props.loadThumbnail}
        uploadRequest={this.props.uploadRequest}
        fileContextKey={this.props.fileContextKey}
      />
    );
  }

  renderWebcam() {
    return (
      <Dialog size="small" onRequestHide={this.props.onRequestHide}>
        <BoxBody>
          <WebcamAvatarShooter onPictureTaken={this.handlePictureTaken} />
        </BoxBody>
      </Dialog>
    );
  }

  render() {
    if (this.state.view === 'webcam') {
      return this.renderWebcam();
    } else if (this.state.view === 'editor') {
      return this.renderEditor();
    }

    return null;
  }
}

export default WebcamAvatarModal;
